module.exports = __webpack_public_path__ + "img/scene2-8.69ed4bc7.jpg";